import { render, staticRenderFns } from "./ClientListPage.vue?vue&type=template&id=3f2392ce&"
import script from "./ClientListPage.vue?vue&type=script&lang=ts&"
export * from "./ClientListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports